import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
var _excluded = ["children", "className"];
var FilterMenu = function FilterMenu(props) {
  var children = props.children,
    className = props.className,
    extraProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: _formatClassName([className, 'filter-menu'])
  }, extraProps), children);
};
FilterMenu.displayName = "FilterMenu";
FilterMenu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export { FilterMenu };